import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useState } from 'react';
import { CardBody } from 'reactstrap';

// This chart Used in Call Perfomance Tab

const generateOptions = (
  responseData,
  yAxisTitle,
  xAxisTitle,
  barColors,
  title,
  suffix,
) => {
  if (!responseData) return;

  const categories = Object.keys(responseData); // ['05-05-2025', ...]
  const values = Object.values(responseData); // [16.1, 52.5, ...]
  const data = values.map((val, i) => {
    const baseColor = barColors[i % barColors.length];

    return {
      y: val,
      color: {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
          [0, hexToRGBA(baseColor, 1)],
          [1, hexToRGBA(baseColor, 0.3)],
        ],
      },
    };
  });

  let maxValue = undefined;
  let tickInterval = undefined;

  if (suffix === '%') {
    maxValue = 100;
    tickInterval = 20;
  }

  return {
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
    },
    title: { text: null },
    xAxis: {
      categories,
      crosshair: true,
      title: { text: xAxisTitle },
    },
    yAxis: {
      min: 0,

      max: maxValue,
      tickInterval: tickInterval,
      title: { text: yAxisTitle },
      labels: {
        formatter: function () {
          return this.value + suffix;
        },
      },
    },
    legend: { enabled: false },
    plotOptions: {
      column: {
        grouping: true,
        borderWidth: 0,
        pointWidth: 10,
        dataLabels: {
          enabled: true,
          color: 'black',
          style: { fontSize: '10px', fontWeight: 'bold' },
          verticalAlign: 'middle',
          align: 'left',
          crop: false,
          overflow: 'none',
          x: 10,
          formatter: function () {
            return this.y + suffix;
          },
        },
      },
    },
    series: [
      {
        name: title,
        colorByPoint: true,
        data,
      },
    ],
    credits: { enabled: false },
    exporting: {
      enabled: true,
      chartOptions: {
        title: { text: title },
      },
    },
  };
};

const hexToRGBA = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const PlotBarChart = ({
  options,
  yAxisTitle = '% Students',
  xAxisTitle = 'Date',
  title,
  suffix = '%',
  barColors = [
    '#9397FF',
    '#9397FF',
    '#9397FF',
    '#9397FF',
    '#9397FF',
    '#9397FF',
    '#9397FF',
    '#9397FF',
  ],
}) => {
  const [assessmentDiscussionOptions, setassessmentDiscussionOptions] =
    useState(null);
  useEffect(() => {
    setassessmentDiscussionOptions(
      generateOptions(
        options,
        yAxisTitle,
        xAxisTitle,
        barColors,
        title,
        suffix,
      ),
    );
  }, [options]);

  if (!options || !assessmentDiscussionOptions) return;

  return (
    <>
      <CardBody>
        <div className="">
          <h5 className="f-16 bold d-flex align-items-center mb-3">{title}</h5>
          <HighchartsReact
            highcharts={Highcharts}
            options={assessmentDiscussionOptions}
          />
        </div>
      </CardBody>
    </>
  );
};

export default PlotBarChart;
